import { render, staticRenderFns } from "./BookableCategorySingleEdit.vue?vue&type=template&id=3365d964"
import script from "./BookableCategorySingleEdit.vue?vue&type=script&lang=js"
export * from "./BookableCategorySingleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports